/*
  HANNE BLOCH product page (D5). Loaded only on product pages (templates/product.json, block "HB details").
  - The four details tabs: a bottom sheet on the phone, inline in the sticky column on desktop (>= 1000 px).
  - Any element with data-hb-open="description|fit|care|delivery" opens that tab (the tab names on the page,
    "Size guide", the trust line).
  - "Arrives Oct 12 – 13": read from the theme's own product delivery estimate (.product-delivery-date).
  - Fit: a small photo per model, matched by the size in each photo's alt text.
  - Desktop: the column is never taller than the part of the screen it sits in.
  Written defensively: the theme may re-render the product section (variant change), so everything is looked up
  at the moment it is used and click handling is delegated to the document.
*/
(function () {
  'use strict';
  if (window.__hbPdp) return;
  window.__hbPdp = true;

  var DESK = '(min-width: 1000px)';
  var isDesk = function () { return window.matchMedia(DESK).matches; };
  var lastFocus = null;

  function det() { return document.querySelector('[data-hb-det]'); }
  function sheetEl() { return document.querySelector('[data-hb-sheet]'); }
  function scrimEl() { return document.querySelector('[data-hb-scrim]'); }
  var home = null; // where the sheet lives in the column; on the phone it is lifted to <body> while open

  function selectTab(root, key) {
    if (!root) return;
    root.querySelectorAll('[data-hb-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', String(t.getAttribute('data-hb-tab') === key));
    });
    root.querySelectorAll('[data-hb-panel]').forEach(function (p) {
      p.classList.toggle('is-hidden', p.getAttribute('data-hb-panel') !== key);
    });
    root.querySelectorAll('[data-hb-panel]').forEach(function (p) { p.scrollTop = 0; });
  }

  function openSheet(key) {
    var sheet = sheetEl();
    if (!sheet) return;
    var key2 = sheet.querySelector('[data-hb-panel="' + key + '"]') ? key : 'description';
    selectTab(sheet, key2);
    if (isDesk()) {
      var tabs = sheet.querySelector('.hb-tabs');
      if (tabs && tabs.getBoundingClientRect().top > window.innerHeight - 80) {
        tabs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    var scrim = scrimEl();
    // lift the sheet out of the column so no stacking context of the theme can hold it under the header or the photos
    if (sheet.parentNode !== document.body) {
      home = { parent: sheet.parentNode, next: sheet.nextSibling, scrimParent: scrim ? scrim.parentNode : null };
      document.body.appendChild(sheet);
      if (scrim) document.body.appendChild(scrim);
      sheet.getBoundingClientRect(); // let the closed position apply before animating in
    }
    lastFocus = document.activeElement;
    sheet.style.transform = '';
    sheet.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    document.documentElement.classList.add('hb-locked');
    sheet.focus({ preventScroll: true });
  }

  function putBack() {
    var sheet = document.querySelector('body > [data-hb-sheet]');
    var scrim = document.querySelector('body > [data-hb-scrim]');
    if (!sheet || sheet.classList.contains('is-open')) return;
    if (home && home.parent && document.contains(home.parent) && !home.parent.querySelector('[data-hb-sheet]')) {
      home.parent.insertBefore(sheet, home.next && home.next.parentNode === home.parent ? home.next : null);
      if (scrim) (home.scrimParent && document.contains(home.scrimParent) ? home.scrimParent : home.parent).appendChild(scrim);
    } else {
      // the section was re-rendered meanwhile: the new column has its own sheet, so drop this one
      sheet.remove(); if (scrim) scrim.remove();
    }
    home = null;
  }

  function closeSheet() {
    var sheet = sheetEl();
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    var scrim = scrimEl();
    if (scrim) scrim.classList.remove('is-open');
    document.documentElement.classList.remove('hb-locked');
    sheet.style.transform = '';
    setTimeout(putBack, 360);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- Desktop: "See how it fits" shows the size photos large over the photographs; the column stays ---------- */
  var fv = null;
  function fitViewLayout() {
    if (!fv) return;
    var col = document.querySelector('.product-information .product-details');
    var hdr = document.querySelector('#header-component');
    var r = col ? col.getBoundingClientRect() : null;
    // flush with the bottom of the header, so no sliver of the photographs shows between the two
    var top = Math.max(0, hdr ? Math.floor(hdr.getBoundingClientRect().bottom) : 0);
    if (r && r.bottom < top + 160) { closeFitView(); return; } // the column has scrolled away
    fv.style.top = top + 'px';
    fv.style.right = (r ? Math.max(0, Math.round(window.innerWidth - r.left)) : 460) + 'px';
    var row = fv.querySelector('.hb-fitview__row');
    var n = fv.querySelectorAll('.hb-fitview__item').length || 1;
    // up to three sizes: all side by side. Four or more: two large photos, the next one peeking in, arrows to move on
    var car = n > 3;
    fv.classList.toggle('is-carousel', car);
    var W = row.clientWidth, hf = Math.floor((row.clientHeight - 56) * 2 / 3);
    var w = car ? Math.min(hf, Math.floor((W - 24 - 4 - 72) / 2)) : Math.min(hf, Math.floor((W - (n - 1) * 4) / n));
    fv.style.setProperty('--hb-fv-w', Math.max(120, w) + 'px');
    fitViewNav();
  }
  function fitViewNav() {
    if (!fv) return;
    var row = fv.querySelector('.hb-fitview__row');
    var car = fv.classList.contains('is-carousel');
    var max = row.scrollWidth - row.clientWidth;
    var prev = fv.querySelector('.hb-fitview__arrow--prev');
    var next = fv.querySelector('.hb-fitview__arrow--next');
    if (prev) prev.hidden = !car || row.scrollLeft <= 2;
    if (next) next.hidden = !car || row.scrollLeft >= max - 2;
    var rl = row.getBoundingClientRect();
    var idx = fv.querySelectorAll('.hb-fitview__idx');
    fv.querySelectorAll('.hb-fitview__item').forEach(function (it, i) {
      var b = it.getBoundingClientRect();
      var seen = Math.min(b.right, rl.right) - Math.max(b.left, rl.left);
      if (idx[i]) idx[i].classList.toggle('is-in', seen > b.width * 0.6);
    });
  }
  function fitViewGo(target) {
    if (!fv) return;
    var row = fv.querySelector('.hb-fitview__row');
    var items = fv.querySelectorAll('.hb-fitview__item');
    var rl = row.getBoundingClientRect();
    var i = typeof target === 'number' ? target : -1;
    if (target === 'next' || target === 'prev') {
      // from the first photo fully in view, one step on or back
      var first = 0;
      for (var k = 0; k < items.length; k++) { if (items[k].getBoundingClientRect().left >= rl.left - 8) { first = k; break; } }
      i = target === 'next' ? Math.min(items.length - 1, first + 1) : Math.max(0, first - 1);
    }
    if (!items[i]) return;
    row.scrollTo({ left: row.scrollLeft + items[i].getBoundingClientRect().left - rl.left, behavior: 'smooth' });
  }
  function closeFitView() {
    if (!fv) return;
    fv.remove(); fv = null;
  }
  // startAt: the index of the size photo that was clicked, so the view opens on that size (Vic, 2026-10-09: it opened
  // on XS whichever photo was clicked). Without it, the view opens on the chosen size.
  function openFitView(startAt) {
    var strip = document.querySelector('[data-hb-sheet] [data-hb-fitstrip]');
    if (!strip) return;
    closeFitView();
    var chosen = document.querySelector('.product-information .variant-option--buttons input:checked');
    chosen = chosen ? String(chosen.value).toUpperCase() : '';
    fv = document.createElement('div');
    fv.className = 'hb-fitview';
    fv.setAttribute('role', 'dialog');
    fv.setAttribute('aria-label', 'See how it fits');
    fv.tabIndex = -1;
    var head = document.createElement('div');
    head.className = 'hb-fitview__head';
    var h = document.createElement('p');
    h.className = 'hb-fitview__title';
    h.textContent = 'See how it fits';
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'hb-fitview__close';
    x.setAttribute('aria-label', 'Close');
    x.setAttribute('data-hb-fitview-close', '');
    var nav = document.createElement('div');
    nav.className = 'hb-fitview__nav';
    head.appendChild(h); head.appendChild(nav); head.appendChild(x);
    var stage = document.createElement('div');
    stage.className = 'hb-fitview__stage';
    var row = document.createElement('div');
    row.className = 'hb-fitview__row';
    row.addEventListener('scroll', fitViewNav, { passive: true });
    strip.querySelectorAll('.hb-fitstrip__item').forEach(function (it) {
      var f = it.cloneNode(true);
      f.className = 'hb-fitview__item';
      f.removeAttribute('role');
      var img = f.querySelector('img');
      if (img) {
        var src = img.currentSrc || img.src;
        img.removeAttribute('srcset'); img.removeAttribute('sizes');
        img.loading = 'eager';
        img.src = src.replace(/([?&])width=\d+/, '$1width=1000');
      }
      var size = it.getAttribute('data-hb-fit-size') || '';
      if (chosen && size.toUpperCase() === chosen) f.classList.add('is-chosen');
      row.appendChild(f);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hb-fitview__idx';
      b.setAttribute('data-hb-fitview-go', String(row.children.length - 1));
      b.textContent = size;
      nav.appendChild(b);
    });
    stage.appendChild(row);
    ['prev', 'next'].forEach(function (dir) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'hb-fitview__arrow hb-fitview__arrow--' + dir;
      a.setAttribute('aria-label', dir === 'next' ? 'More sizes' : 'Back');
      a.setAttribute('data-hb-fitview-go', dir);
      a.hidden = true;
      stage.appendChild(a);
    });
    fv.appendChild(head); fv.appendChild(stage);
    document.body.appendChild(fv);
    fitViewLayout();
    // land on the clicked size (or the chosen one) before the fade-in, without the carousel's smooth scroll
    var items = row.querySelectorAll('.hb-fitview__item');
    var at = typeof startAt === 'number' ? startAt : -1;
    if (at < 0) { for (var k = 0; k < items.length; k++) { if (items[k].classList.contains('is-chosen')) { at = k; break; } } }
    if (at > 0 && items[at]) {
      row.style.scrollBehavior = 'auto';
      row.scrollLeft = Math.max(0, row.scrollLeft + items[at].getBoundingClientRect().left - row.getBoundingClientRect().left);
      row.style.scrollBehavior = '';
      fitViewNav();
    }
    requestAnimationFrame(function () { if (fv) fv.classList.add('is-open'); });
    fv.focus({ preventScroll: true });
  }
  window.addEventListener('scroll', fitViewLayout, { passive: true });
  window.addEventListener('resize', fitViewLayout);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hb-fitview-close]')) { closeFitView(); return; }
    var go = e.target.closest('[data-hb-fitview-go]');
    if (go) { var g = go.getAttribute('data-hb-fitview-go'); fitViewGo(/^\d+$/.test(g) ? parseInt(g, 10) : g); return; }
    var fvt = e.target.closest('[data-hb-fitview-open], [data-hb-sheet] .hb-fitstrip__item');
    if (fvt && isDesk()) {
      e.preventDefault();
      var fvStrip = fvt.closest('[data-hb-fitstrip]');
      openFitView(fvStrip ? Array.prototype.indexOf.call(fvStrip.querySelectorAll('.hb-fitstrip__item'), fvt) : -1);
      return;
    }
    var o = e.target.closest('[data-hb-open]');
    if (o) {
      e.preventDefault();
      openSheet(o.getAttribute('data-hb-open'));
      // "Size guide" on desktop: the Fit tab, and the size photos large at once (they asked to see how it fits)
      if (isDesk() && o.getAttribute('data-hb-open') === 'fit' && o.closest('.hb-size-guide-row, .hb-size-guide')) openFitView();
      return;
    }
    var t = e.target.closest('[data-hb-tab]');
    if (t && t.closest('[data-hb-sheet]')) { selectTab(t.closest('[data-hb-sheet]'), t.getAttribute('data-hb-tab')); return; }
    if (e.target.closest('[data-hb-close]') || e.target.closest('[data-hb-scrim]')) closeSheet();
  });
  // "See how it fits" opens the theme's own pop-up: close the sheet first so the pop-up is not hidden behind it
  // (capture phase: the pop-up's own handler stops the click from bubbling)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-hb-sheet] .hb-dx__link')) closeSheet();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeFitView(); closeSheet(); }
    if (fv && fv.classList.contains('is-carousel') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft') && !(e.target.closest && e.target.closest('[data-hb-tab], input, select, textarea'))) {
      e.preventDefault(); fitViewGo(e.key === 'ArrowRight' ? 'next' : 'prev');
    }
    var t = e.target.closest && e.target.closest('[data-hb-tab]');
    if (t && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
      var list = Array.prototype.slice.call(t.parentNode.querySelectorAll('[data-hb-tab]'));
      var n = list[(list.indexOf(t) + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
      n.click(); n.focus();
    }
  });

  // pull the sheet down to close (phone)
  (function () {
    var y0 = null, dy = 0, sheet = null;
    document.addEventListener('touchstart', function (e) {
      var head = e.target.closest('[data-hb-sheet-head]');
      if (!head) return;
      sheet = head.closest('[data-hb-sheet]'); y0 = e.touches[0].clientY; dy = 0;
      sheet.style.transition = 'none';
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (y0 === null || !sheet) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    document.addEventListener('touchend', function () {
      if (y0 === null || !sheet) return;
      sheet.style.transition = '';
      if (dy > 90) closeSheet(); else sheet.style.transform = '';
      y0 = null; sheet = null;
    });
  })();

  // leaving phone width with the sheet open: close it (desktop shows the tabs inline)
  window.matchMedia(DESK).addEventListener('change', function () { closeSheet(); closeFitView(); fitColumn(); });

  /* ---------- "Arrives Oct 12 – 13" from the theme's product delivery estimate ---------- */
  var MONTHS = (function () {
    var map = {};
    for (var m = 0; m < 12; m++) {
      var d = new Date(2026, m, 15);
      var en = d.toLocaleDateString('en-US', { month: 'short' });
      [undefined, 'en-US', 'da-DK'].forEach(function (loc) {
        try {
          map[d.toLocaleDateString(loc, { month: 'long' }).toLowerCase().replace('.', '')] = en;
          map[d.toLocaleDateString(loc, { month: 'short' }).toLowerCase().replace('.', '')] = en;
        } catch (err) { /* ignore */ }
      });
    }
    return map;
  })();

  function shortArrival(text) {
    // "Order now - arrives October 12 – 13" / "… October 30 – November 2"
    var m = (text || '').replace(/\s+/g, ' ').match(/arrives\s+([^\d\s–-]+)\s*(\d{1,2})(?:\s*[–-]\s*(?:([^\d\s–-]+)\s*)?(\d{1,2}))?/i);
    if (!m) return '';
    var m1 = MONTHS[m[1].toLowerCase().replace('.', '')];
    if (!m1) return '';
    var out = m1 + ' ' + m[2];
    if (m[4]) {
      var m2 = m[3] ? MONTHS[m[3].toLowerCase().replace('.', '')] : '';
      out += ' – ' + (m2 && m2 !== m1 ? m2 + ' ' : '') + m[4];
    }
    return out;
  }

  function applyArrival() {
    var src = document.querySelector('.product-delivery-date');
    var a = shortArrival(src ? src.textContent : '');
    document.querySelectorAll('[data-hb-arrival]').forEach(function (el) {
      el.hidden = !a;
      var txt = a ? 'Arrives ' + a : '';
      if (el.textContent !== txt) el.textContent = txt;
    });
    document.querySelectorAll('[data-hb-arrival-long]').forEach(function (el) {
      var row = el.closest('[data-hb-arrival-row]') || el;
      if (row.hidden !== !a) row.hidden = !a;
      var txt = a ? a + ', when you order today' : '';
      if (el.textContent !== txt) el.textContent = txt;
    });
  }

  /* ---------- Fit: a small photo of each model, by the size in the photos' alt text ---------- */
  function applyModelThumbs() {
    var d = sheetEl();
    if (!d) return;
    var data = d.querySelector('[data-hb-model-media]');
    if (!data || data.dataset.done) return;
    data.dataset.done = '1';
    var media = [];
    try { media = JSON.parse(data.textContent).filter(Boolean); } catch (err) { return; }
    if (!media.length) return;
    var bySize = {};
    media.forEach(function (m) {
      var s = (m.alt || '').match(/\bsize\s+(XXS|XS|S|M|L|XL|XXL)\b/i);
      if (s && !bySize[s[1].toUpperCase()]) bySize[s[1].toUpperCase()] = m.src;
    });
    d.querySelectorAll('[data-hb-model]').forEach(function (row) {
      if (row.querySelector('.hb-model__img')) return;
      var t = row.textContent;
      var s = row.dataset.hbSize ? [0, row.dataset.hbSize] : t.match(/\bwears?\s+(?:size\s+)?(XXS|XS|S|M|L|XL|XXL)\b/i) || t.match(/\(size\s+(XXS|XS|S|M|L|XL|XXL)\)/i);
      if (!s) return;
      var src = bySize[s[1].toUpperCase()];
      if (!src) return;
      var fig = document.createElement('figure');
      fig.className = 'hb-model__img';
      var img = document.createElement('img');
      img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 46; img.height = 69;
      fig.appendChild(img);
      row.appendChild(fig);
      row.classList.add('has-thumb');
    });
  }

  /* ---------- Desktop: the column never taller than the visible part of the screen ---------- */
  function fitColumn() {
    var col = document.querySelector('.product-information .product-details');
    if (!col) return;
    if (!isDesk() || !document.querySelector('[data-hb-det]')) { col.style.removeProperty('--hb-col-max'); return; }
    // as tall as the screen under the sticky header: at the very top of the page the announcement bar pushes its last
    // few lines just below the fold, and the first bit of scrolling brings them up (no scrolling inside the tabs)
    var hdr = document.querySelector('#header-component');
    var hh = hdr ? hdr.getBoundingClientRect().height : 0;
    col.style.setProperty('--hb-col-max', Math.round(window.innerHeight - hh) + 'px');
  }

  /* ---------- Photographs: ask for files as wide as the two-up grid really shows them ---------- */
  // The theme sizes the grid photos for a half-width gallery (50vw / 2); here the gallery is the page minus the
  // 460 px column, so on desktop each photo is shown wider and would otherwise load too small (soft on a retina screen).
  var SIZES = '(min-width: 1000px) calc((100vw - 460px) / 2), (min-width: 750px) 25vw, 100vw';
  function gallerySizes() {
    if (!det()) return;
    document.querySelectorAll('.product-information .media-gallery__grid img[srcset]').forEach(function (img) {
      if (img.getAttribute('sizes') !== SIZES) img.setAttribute('sizes', SIZES);
    });
  }

  /* ---------- Sizes that are words (Regular, Short): a pill instead of a ring ---------- */
  function pills() {
    if (!det()) return;
    document.querySelectorAll('.product-information .variant-option--buttons .variant-option__button-label').forEach(function (l) {
      var long = (l.textContent || '').trim().length > 3;
      if (l.classList.contains('hb-pill') !== long) l.classList.toggle('hb-pill', long);
    });
  }

  /* ---------- Follow us on Instagram: every tile is a link (to the product shown, else to our Instagram) ---------- */
  var VC = null;
  function igLinks() {
    if (!det()) return;
    if (VC === null) {
      var el = document.querySelector('[data-hb-vc]');
      VC = false;
      try { if (el) { VC = JSON.parse(el.textContent); VC.items = (VC.items || []).filter(Boolean); } } catch (err) { VC = false; }
    }
    if (!VC) return;
    document.querySelectorAll('[id*="__video_carousel_metafields_"] .video-resource-card__media').forEach(function (tile) {
      if (tile.querySelector('.hb-vc-link')) return;
      var tEl = tile.querySelector('.video-product-title');
      var title = tEl ? tEl.textContent.replace(/\s+/g, ' ').trim() : '';
      var hit = null;
      if (title) VC.items.forEach(function (it) { if (!hit && it.t === title) hit = it; });
      var a = document.createElement('a');
      a.className = 'hb-vc-link';
      if (hit) {
        a.href = hit.u;
        a.setAttribute('aria-label', hit.n || hit.t);
        if (tEl && hit.n) tEl.textContent = hit.n; // Color + Style, as on the product cards
      } else {
        a.href = VC.ig; a.target = '_blank'; a.rel = 'noopener';
        a.setAttribute('aria-label', 'HANNE BLOCH on Instagram');
      }
      tile.appendChild(a);
      // the struck price ended in a space, so the line ran past the number
      tile.querySelectorAll('.video-product-price s, .video-product-price .price').forEach(function (el) {
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (el.textContent !== t) el.textContent = t;
      });
    });
  }

  /* ---------- Recently viewed: never more than two lines for a name ---------- */
  function rvNames() {
    if (!det()) return;
    document.querySelectorAll('ul.recently-viewed .hb-name').forEach(function (n) {
      n.classList.remove('hb-name--flow');
      var lh = parseFloat(getComputedStyle(n).fontSize) * 1.3;
      if (n.getBoundingClientRect().height > lh * 2.4) n.classList.add('hb-name--flow');
    });
  }
  // the row is filled after the page loads and the fonts arrive later: measure again whenever the row changes size
  var rvRO = null;
  function rvWatch() {
    if (!det() || !window.ResizeObserver) return;
    document.querySelectorAll('ul.recently-viewed').forEach(function (ul) {
      if (ul.hbWatched) return;
      ul.hbWatched = true;
      if (!rvRO) rvRO = new ResizeObserver(function () { rvNames(); });
      rvRO.observe(ul);
    });
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { rvNames(); });

  /* ---------- One-size pieces: "ONE SIZE FITS XS–XXL" becomes the size line (a One Size ring, then "Fits XS–XXL") ---------- */
  function oneSize() {
    if (!det()) return;
    document.querySelectorAll('.product-information .one-size-fits-all').forEach(function (p) {
      if (p.querySelector('.hb-onesize__ring')) return;
      var m = (p.textContent || '').replace(/\s+/g, ' ').trim().match(/fits\s+(.+)$/i);
      p.textContent = '';
      var ring = document.createElement('span');
      ring.className = 'hb-onesize__ring';
      ring.textContent = 'One Size';
      p.appendChild(ring);
      if (m) {
        var fits = document.createElement('span');
        fits.className = 'hb-onesize__fits';
        fits.textContent = 'Fits ' + m[1].replace(/\s*[–-]\s*/, ' – ');
        p.appendChild(fits);
      }
      p.classList.add('hb-onesize');
    });
  }

  /* ---------- As seen on: the pop-up links to the post on Instagram (the theme's tiles link to it, but never open it) ---------- */
  function asSeenLinks() {
    if (!det()) return;
    var tiles = document.querySelectorAll('.instragram_wrapper .navigate_image > a.swiper-slide');
    var k = 0;
    document.querySelectorAll('.insta--product-popup-modal .slider-item-media').forEach(function (item) {
      if (!item.querySelector('img')) return; // the tiles leave out entries without a photo
      var tile = tiles[k++];
      var bio = item.querySelector('.insta_bio');
      if (!bio || bio.querySelector('a')) return;
      var href = tile ? tile.getAttribute('href') || '' : '';
      if (!/instagram\.com/i.test(href)) href = 'https://www.instagram.com/hannebloch/';
      var handle = bio.textContent.replace(/\s+/g, ' ').trim();
      var a = document.createElement('a');
      a.href = href; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = (handle && handle.toLowerCase() !== '@hannebloch' ? handle + ' · ' : '') + 'View on Instagram';
      bio.textContent = '';
      bio.appendChild(a);
    });
  }

  /* the "See how it fits" link under the small size photos (shown on desktop only, by hb-pdp.css) */
  function fitOpenLink() {
    var strip = document.querySelector('[data-hb-sheet] [data-hb-fitstrip]');
    if (!strip) return;
    var next = strip.nextElementSibling;
    if (next && next.hasAttribute('data-hb-fitview-open')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'hb-dx__link hb-fitstrip__open';
    b.setAttribute('data-hb-fitview-open', '');
    b.textContent = 'See how it fits';
    strip.parentNode.insertBefore(b, strip.nextSibling);
  }

  /* ---------- The size that is chosen when the page opens (Vic, 2026-10-09): the size she chose before, in this browser,
     else M, else the nearest size in stock (M, L, S, XL, XS, XXL ...), the quick add's own order. Only for options that
     are letter sizes; Regular / Short and One size are left to the theme. Her own choices are remembered when she taps a
     size (here, in the quick add on the collection pages via hb-cart.js, and in the cart's size pills). ---------- */
  var SIZE_RANK = ['M', 'L', 'S', 'XL', 'XS', 'XXL', 'XXS', 'XXXL', '3XL'];
  var presetting = false;
  // HB 2026-10-09 (Vic, afternoon): the color swatches on the page swap the product in the same document (the theme
  // fetches the other product's section and replaces it), so "once per page" left the swapped product on the theme's
  // first size (XS). The preset is keyed on the product id of the picker instead and runs again for a new product.
  var presetFor = null;
  function sizeInputs(fs) { return Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')); }
  function isLetterSizeSet(inputs) {
    if (!inputs.length) return false;
    var letters = 0;
    for (var i = 0; i < inputs.length; i++) {
      var v = String(inputs[i].value || '').trim().toUpperCase();
      if (SIZE_RANK.indexOf(v) !== -1) letters += 1;
      else if (v !== 'ONE SIZE') return false; // Regular / Short, TOP / BOT names, numbers: not a size run
    }
    return letters > 0;
  }
  function inStock(input) {
    if (input.disabled) return false;
    if (input.getAttribute('data-option-available') === 'false') return false;
    var label = input.closest('label');
    if (label && /unavailable|sold-out|disabled/.test(label.className)) return false;
    return true;
  }
  function presetSizes() {
    var picker = document.querySelector('.product-information variant-picker');
    if (!picker) return;
    var pid = picker.getAttribute('data-product-id') || picker.getAttribute('data-product-url') || 'page';
    if (presetFor === pid) return;
    var sets = Array.prototype.slice.call(picker.querySelectorAll('fieldset.variant-option--buttons'));
    if (!sets.length) return;
    presetFor = pid;
    var pref = '';
    try { pref = String(localStorage.getItem('hb-size') || '').toUpperCase(); } catch (_) {}
    var order = SIZE_RANK.slice();
    if (pref && order.indexOf(pref) !== -1) { order.splice(order.indexOf(pref), 1); order.unshift(pref); }
    var step = function (idx) {
      var fs = document.querySelectorAll('.product-information variant-picker fieldset.variant-option--buttons')[idx];
      if (!fs) return;
      var inputs = sizeInputs(fs);
      if (isLetterSizeSet(inputs)) {
        var target = null;
        for (var r = 0; r < order.length && !target; r++) {
          for (var i = 0; i < inputs.length; i++) {
            if (String(inputs[i].value).trim().toUpperCase() === order[r] && inStock(inputs[i])) { target = inputs[i]; break; }
          }
        }
        if (target && !target.checked) {
          presetting = true;
          target.click(); // the theme's own change handling: price, photos and the address follow
          setTimeout(function () { presetting = false; }, 0);
          // the section may re-render after a change; take the next size run a moment later
          setTimeout(function () { step(idx + 1); }, 250);
          return;
        }
      }
      step(idx + 1);
    };
    step(0);
  }
  document.addEventListener('change', function (e) {
    if (presetting) return;
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.closest('.product-information variant-picker')) return;
    var v = String(input.value || '').trim().toUpperCase();
    if (SIZE_RANK.indexOf(v) === -1) return;
    try { localStorage.setItem('hb-size', v); } catch (_) {}
  }, true);

  /* ---------- Phone: the hairline under the tab names moves down to sit just above the next section (Vic, 2026-10-09),
     so the names get the air. The first section after the product information that has content carries it. ---------- */
  function hairlineAfterTabs() {
    var pi = document.querySelector('.product-information');
    var section = pi && pi.closest('.shopify-section');
    if (!section) return;
    var s = section.nextElementSibling;
    while (s && s.getBoundingClientRect().height < 2) s = s.nextElementSibling;
    if (!s || s.classList.contains('hb-after-tabs')) return;
    document.querySelectorAll('.hb-after-tabs').forEach(function (el) { el.classList.remove('hb-after-tabs'); });
    s.classList.add('hb-after-tabs');
  }

  function init() {
    presetSizes();
    hairlineAfterTabs();
    fitOpenLink();
    asSeenLinks();
    oneSize();
    igLinks();
    pills();
    applyArrival();
    applyModelThumbs();
    rvNames();
    rvWatch();
    gallerySizes();
    fitColumn();
  }

  window.addEventListener('scroll', fitColumn, { passive: true });
  window.addEventListener('resize', fitColumn);
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  // the delivery estimate and the variant re-render both change the DOM later; re-apply cheaply
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    var run = function () { pending = false; init(); };
    // HB 2026-10-09: requestAnimationFrame is paused in a hidden tab (a product opened in the background, a hidden
    // preview pane), so a swatch swap made there would keep the theme's first size until the tab shows; a timer instead.
    if (document.hidden) setTimeout(run, 50); else requestAnimationFrame(run);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  init();
})();
